import { useCallback, useEffect, useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../hooks/useAuth';

interface LikeButtonProps {
  puzzleId: string;
  initialCount?: number;
  initialLiked?: boolean;
}

export function LikeButton({ puzzleId, initialCount = 0, initialLiked = false }: LikeButtonProps) {
  const { user } = useAuth();
  const [liked, setLiked] = useState(initialLiked);
  const [count, setCount] = useState(initialCount);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setLiked(initialLiked);
    setCount(initialCount);
  }, [initialLiked, initialCount, puzzleId]);

  const toggle = useCallback(async () => {
    if (!user || busy) return;
    setBusy(true);
    try {
      const res = await api<{ liked: boolean; likeCount: number }>(`/puzzles/${puzzleId}/like`, {
        method: 'POST',
      });
      setLiked(res.liked);
      setCount(res.likeCount);
    } catch {
      /* silent */
    } finally {
      setBusy(false);
    }
  }, [user, busy, puzzleId]);

  if (!user) return null;

  return (
    <button
      type="button"
      className={`like-btn${liked ? ' liked' : ''}`}
      onClick={toggle}
      disabled={busy}
      aria-pressed={liked}
    >
      <span aria-hidden>{liked ? '♥' : '♡'}</span>
      <span>{liked ? 'Aimé' : 'J\'aime cette photo'}</span>
      {count > 0 && <span className="like-count">{count}</span>}
    </button>
  );
}
